'use strict';

var id = 1;

function index () {
  return "" + id++;
}

module.exports = index;